import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="The-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path d="M14,40.0007252 C14,40.0027408 34.0031611,40 34.0031611,40 C33.9992893,40 33.9996832,20.4059708 33.9999154,14 L14,14 L14,40.0007252 Z M38,40.0007252 C38,42.2094637 36.2058797,44 34.0031611,44 L13.9968389,44 C11.7894457,44 10,42.2132053 10,40.0007252 L10,13.9999993 C8.89526901,13.9990666 8,13.1116856 8,12 C8,10.8954305 8.88926172,10 10.0017433,10 L20,10 C20,7.790861 21.790861,6 24,6 C26.209139,6 28,7.790861 28,10 L37.9982567,10 C39.103789,10 40,10.8877296 40,12 C40,13.1039925 39.1116671,13.9990644 38,13.9999993 L38,40.0007252 Z M26,19.9950893 C26,18.8932319 26.8877296,18 28,18 C29.1045695,18 30,18.8926228 30,19.9950893 L30,34.0049107 C30,35.1067681 29.1122704,36 28,36 C26.8954305,36 26,35.1073772 26,34.0049107 L26,19.9950893 Z M18,19.9950893 C18,18.8932319 18.8877296,18 20,18 C21.1045695,18 22,18.8926228 22,19.9950893 L22,34.0049107 C22,35.1067681 21.1122704,36 20,36 C18.8954305,36 18,35.1073772 18,34.0049107 L18,19.9950893 Z" id="Combined-Shape" fill={color} fillRule="nonzero"></path>
        </g>
    </svg>
)

export default class IconRemove extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
